import styled from 'styled-components'

type StyledProps = {
  lastTag?: string
}

const StyledPostsViewHeader = styled.div<StyledProps>`
  .posts-view-header-top {
    display: grid;
    grid-gap: 12px;
  }

  .bubbles {
    margin-top: 12px;

    [data-key='hide-used-separator'], [data-key='${({ lastTag }) => lastTag}-separator'] {
      width: 20px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 22px;
        width: 1px;
        border-radius: 6px;
        background-color: ${({ theme }) => theme.color.gray[300]};
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.m}px) {
    .posts-view-header-top {
      grid-template-columns: minmax(0, 1fr) 185px;

      .input,
      .select,
      .btn {
        grid-column: unset;
      }
    }
  }
`

export default StyledPostsViewHeader
